module.exports = __webpack_public_path__ + "img/lfu.f6de0a52.png";